import { UIState } from './types'

export const initialState: UIState = {
  toasts: []
}

